import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { HiMiniBars3 } from "react-icons/hi2";
import { SAVE_PROJECT_TASKS_ORDERING } from "../projectTasks/graphql";

const SortTasksView = ({ initialTasks, onCompleted }) => {
  const [tasks, setTasks] = useState(initialTasks);
  const [updateOrdering, updateOrderingRes] = useMutation(
    SAVE_PROJECT_TASKS_ORDERING,
    {
      variables: {
        ids: tasks.map((task) => task.id),
      },
      onCompleted() {
        Alert("success", "Tasks ordering updated.");
        onCompleted();
      },

      onError(error) {
        Alert("error", parseError(error));
      },
      refetchQueries: ["FETCH_PROJECT_TASKS", "FETCH_GTM_PROJECT_TASKS"],
      awaitRefetchQueries: true,
    },
  );

  function updateHandler() {
    // if the tasks has the same ordering with initialTasks, then skip save.
    const originalIds = initialTasks.map((i) => i.id);
    const updatedIds = tasks.map((t) => t.id);

    if (JSON.stringify(originalIds) === JSON.stringify(updatedIds)) {
      onCompleted();
    } else {
      updateOrdering();
    }
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  function onDragEnd(result) {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    const res = reorder(tasks, result.source.index, result.destination.index);
    setTasks(res);
  }

  return (
    <div>
      <div className="text-xs opacity-70 my-2">
        Drag and Drop to set the ordering for the tasks.
      </div>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable-tasks">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {tasks.map((i, index) => (
                <Draggable key={i.id} draggableId={i.id} index={index}>
                  {(provided, snapshot) => {
                    if (snapshot.isDragging) {
                      provided.draggableProps.style = {
                        ...provided.draggableProps.style,
                        left: provided.draggableProps.style.offsetLeft,
                        top: provided.draggableProps.style.offsetTop,
                      };
                    }
                    return (
                      <div
                        className="py-2 border-b border-gray-100 dark:border-gray-700 flex items-center space-x-2"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <HiMiniBars3 />
                        <div>{i.name}</div>
                      </div>
                    );
                  }}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <Button
        className="mt-2"
        onClick={updateHandler}
        loading={updateOrderingRes.loading}
      >
        Done
      </Button>
    </div>
  );
};

export default SortTasksView;
